import { TestLocators } from 'constants/Locators';

import { MUI, MUIIcons, ThemeMode } from 'ci-esi-web-shared';

import { colors } from 'styles/theme/colors';

export interface AlertDialogWithAnyActionsProps {
  isOpen: boolean;
  title: string;
  messages: string[] | null;
  onClose(): void;
  testId?: TestLocators;
  dialogTestId?: TestLocators;
  buttonsContent: JSX.Element;
  optionalBodyContent?: string[];
}
export function AlertDialogWithAnyActions({
  isOpen,
  onClose,
  title,
  messages,
  testId,
  buttonsContent,
  optionalBodyContent,
  dialogTestId,
}: AlertDialogWithAnyActionsProps) {
  const theme = MUI.useTheme();
  const isDarkMode = theme.palette.mode === ThemeMode.DARK;

  return (
    <MUI.Dialog
      closeAfterTransition
      PaperProps={{
        sx: {
          minWidth: 480,
          maxWidth: 560,
          background: isDarkMode ? colors.grey56 : colors.primaryWhite,
        },
      }}
      onClose={onClose}
      open={isOpen}
      data-testid={dialogTestId}
    >
      <MUI.DialogTitle
        sx={{
          backgroundColor: 'warning.main',
          padding: '10px 24px',
        }}
      >
        <MUI.Typography variant="h1" component="h2" data-testid={`${dialogTestId}_title`} sx={{ color: colors.grey60 }}>
          {title}
        </MUI.Typography>
      </MUI.DialogTitle>
      <MUI.DialogContent dividers={!optionalBodyContent} sx={{ display: 'flex' }}>
        <MUIIcons.Warning sx={{ color: 'warning.main', fontSize: 32, marginRight: 1 }} />
        <MUI.Typography component="div" data-testid={testId}>
          {messages?.map((message, i) => (
            <MUI.Typography
              component="p"
              data-testid={`${dialogTestId}_message_${i + 1}`}
              sx={{
                fontWeight: (theme.typography.fontWeightRegular ?? 400) as number,
                lineHeight: '24px',
                width: '100%',
              }}
            >
              {message}
            </MUI.Typography>
          ))}
        </MUI.Typography>
      </MUI.DialogContent>
      {optionalBodyContent && (
        <MUI.DialogContent dividers sx={{ display: 'flex' }}>
          <MUI.Typography component="div" data-testid={testId} sx={{ height: 100, width: '100%', overflow: 'scroll' }}>
            {optionalBodyContent.reduce((prev, curr) => `${prev} ${curr},`)}
          </MUI.Typography>
        </MUI.DialogContent>
      )}
      <MUI.DialogActions sx={{ padding: 1.5 }}>{buttonsContent}</MUI.DialogActions>
    </MUI.Dialog>
  );
}
